import styled from '@emotion/styled';

export const FilterBarContainer = styled.div`
  font-size: 24px;
  line-height: 40px;
  justify-content: space-between;
  margin: 24px 0;
  color: ${props => props.theme.color.text};
`;
